import { api } from "./api";

const API = process.env.REACT_APP_API;

export interface ChannelPermission {
  id: number;
  active_channel: { id: number; title: string | null };
  permission: string; // "all"
  user?: { id: number };
  created_at?: string;
  updated_at?: string | null;
}

/** POST /api/activechannels/{channelId}/permissions  body { user: { id } } */
export async function createChannelPermission(
  channelId: number,
  userId: number
): Promise<ChannelPermission> {
  const response = await api.post(
    `${API}/api/activechannels/${channelId}/permissions`,
    { user: { id: userId } },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
}

/** DELETE /api/activechannels/{channelId}/permissions/{permissionId} */
export async function deleteChannelPermission(
  channelId: number,
  permissionId: number
): Promise<void> {
  await api.delete(
    `${API}/api/activechannels/${channelId}/permissions/${permissionId}`
  );
}

/**
 * Current channel permissions for a user, read off the user object returned by
 * client.Users.getUsers() (mirrors /api/users/me's channel_permissions).
 * SINGLE swap-point if the list payload turns out not to include them.
 */
export function getCuratorPermissions(user: any): ChannelPermission[] {
  return (user && user.channel_permissions) || [];
}
